var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 936.15,
    height: 150,
    viewBox: "0 0 936.15 150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath253-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-225.5-452.99h595.28v841.89h-595.28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath249-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-293.59-460.4h595.28v841.89h-595.28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath245-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-332.49-460.37h595.28v841.89h-595.28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath241-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-376.23-471.89h595.28v841.89h-595.28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath237-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-263.84-471.89h595.28v841.89h-595.28z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 -526.63 571.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.4671 0 0 4.4671 -1369.4 -1486.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(401.43 408.63)",
    clipPath: "url(#clipPath253-5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.248 2.001-2.046 4.712-2.046 7.343 0 2.587 0.679 5.017 1.868 7.117l0.135 0.24c1.191 2.391 3.878 4.027 6.495 4.027v3e-3c1.708 0 3.538-0.504 4.955-1.238 2.574-1.589 4.602-3.97 5.747-6.816v4.317c-5e-3 0.967-1.48 2.021-1.48 2.021-2.513 1.851-5.618 2.915-8.978 2.915-1.362 0-3.274-0.347-3.274-0.347-5.646-1.191-9.873-6.237-9.873-12.239 0-6.405 4.835-11.684 11.055-12.384 0 0 1.285-0.193 2.143-0.136 3.639 0 6.975 1.283 9.588 3.417l0.343 0.392c0.31 0.413 0.499 0.924 0.499 1.48v3.584c0 1.06 0.525 2.003 1.326 2.583h-6.688c0.799-0.58 1.323-1.522 1.323-2.583l0.044-3.354c0-0.669-0.268-1.273-0.705-1.711-0.548-0.609-2.644-1.674-2.644-1.674-1.014-0.545-2.175-0.854-3.406-0.854-2.787 0-5.225 1.574-6.427 3.897",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(469.51 416.04)",
    clipPath: "url(#clipPath249-5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-6.005 4.226-10.927 9.874-12.116 0 0 1.908-0.35 3.274-0.348 3.358 1e-3 6.41 1.051 8.922 2.9 0 0 1.529 0.947 1.535 1.913l0.596 4.565c-1.733-4.306-4.652-5.92-6.343-6.898-1.419-0.738-3.245-1.267-4.956-1.267v4e-3c-2.616 0-5.289 1.495-6.481 3.889l-0.147 0.24c-1.189 2.102-1.87 4.529-1.87 7.118 0 2.588 0.681 5.014 1.87 7.116l0.134 0.239c1.192 2.391 3.878 4.029 6.494 4.029v2e-3c1.711 0 3.537-0.503 4.956-1.24 2.573-1.586 4.602-3.97 5.747-6.81v4.312c-6e-3 0.966-1.479 2.023-1.479 2.023-2.514 1.851-5.62 2.913-8.978 2.915-1.366 3e-3 -3.274-0.348-3.274-0.348-5.648-1.189-9.874-6.235-9.874-12.238",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(508.42 416.02)",
    clipPath: "url(#clipPath245-0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-6.004 4.226-10.926 9.872-12.115 0 0 1.911-0.35 3.273-0.35 3.362 3e-3 6.411 1.05 8.922 2.901 0 0 1.531 0.948 1.537 1.916l0.596 4.559c-1.733-4.301-4.648-5.915-6.344-6.896-1.416-0.736-3.244-1.264-4.951-1.264-2.621 0-5.294 1.499-6.483 3.89l-0.149 0.242c-1.187 2.101-1.868 4.529-1.868 7.117 0 2.586 0.681 5.016 1.868 7.115l0.134 0.242c1.191 2.39 3.877 4.027 6.498 4.027v3e-3c1.707 0 3.535-0.503 4.951-1.24 2.575-1.589 4.603-3.97 5.748-6.814v4.316c-6e-3 0.966-1.479 2.024-1.479 2.024-2.514 1.848-5.618 2.913-8.98 2.914-1.362 3e-3 -3.273-0.347-3.273-0.347-5.646-1.194-9.872-6.238-9.872-12.24",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552.15 427.53)",
    clipPath: "url(#clipPath241-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-6.498c0.799-0.56 1.321-1.478 1.321-2.528v-18.967c0-1.019-0.494-1.924-1.254-2.483h6.364c-0.76 0.559-1.254 1.464-1.254 2.483v18.967c0 1.05 0.522 1.968 1.321 2.528",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(439.77 427.53)",
    clipPath: "url(#clipPath237-0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-6.498c0.799-0.56 1.321-1.502 1.321-2.55l-4e-3 -8e-3v-14.177c0.222-2.584 1.846-4.786 4.11-5.8l0.023-0.013c1.849-0.899 3.907-1.43 6.101-1.43 2.228 0 4.332 0.475 6.199 1.402l0.038 0.015c2.262 1.033 3.875 3.234 4.077 5.83v14.241c0 1.05 0.523 1.93 1.322 2.49h-3.796c0.799-0.56 1.321-1.44 1.321-2.49v-14.241l-4e-3 -0.047c-0.16-1.566-0.922-2.949-2.07-3.904l-0.053-0.051c-1.279-0.989-3.536-1.746-5.661-1.746-1.325 0-2.592 0.278-3.759 0.723l-0.121 0.047c-2.088 0.727-3.628 2.688-3.869 4.961l-3e-3 0.03v14.16l-3e-3 8e-3c0 1.048 0.531 1.99 1.329 2.55",
    fill: "#231f20"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGg);
export default __webpack_public_path__ + "static/media/GG.a80c27cabc9fb17f08752c5708a535c4.svg";
export { ForwardRef as ReactComponent };